// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfileModal_overlay__-Il9D {
  position: fixed;
  inset: 0;
  background: transparent;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 72px 5% 24px;
  z-index: 200;
}

.ProfileModal_modal__FrLVL {
  width: min(340px, 100%);
  background: var(--color-white);
  border: 1px solid var(--color-gray-border);
  border-radius: 14px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}

@media (max-width: 640px) {
  .ProfileModal_overlay__-Il9D {
    justify-content: center;
    padding: 72px 16px 24px;
  }
}

.ProfileModal_header__SeJ28 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 12px 10px;
  border-bottom: 1px solid var(--color-gray-border);
  background: var(--color-white);
}

.ProfileModal_titleWrap__0ls9R {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.ProfileModal_title__BCiG9 {
  margin: 0;
  font-size: 0.98rem;
  font-weight: 800;
  color: var(--color-text-dark);
  letter-spacing: -0.01em;
}

.ProfileModal_sub__F38sC {
  margin: 0;
  font-size: 0.82rem;
  color: rgba(22, 22, 26, 0.65);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ProfileModal_closeBtn__1dv1D {
  appearance: none;
  border: 1px solid var(--color-gray-border);
  background: var(--color-white);
  width: 36px;
  height: 36px;
  border-radius: 12px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 120ms ease, box-shadow 160ms ease, border-color 160ms ease;
}

.ProfileModal_closeBtn__1dv1D:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.10);
  border-color: rgba(171, 0, 96, 0.45);
}

.ProfileModal_closeBtn__1dv1D:focus-visible {
  outline: 2px solid var(--color-main);
  outline-offset: 2px;
}

.ProfileModal_body__WCJXy {
  padding: 12px;
  display: grid;
  gap: 10px;
}

.ProfileModal_row__ScdTB {
  display: grid;
  gap: 10px;
  justify-items: center;
  text-align: center;
}

.ProfileModal_avatar__nGRl- {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: 1px solid var(--color-gray-border);
  overflow: hidden;
  background: linear-gradient(135deg, var(--primary-light), var(--primary-dark));
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 900;
  letter-spacing: 0.4px;
}

.ProfileModal_avatar__nGRl- img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.ProfileModal_rowText__mRqC5 {
  min-width: 0;
}

.ProfileModal_name__Z29pR {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 800;
  color: var(--color-text-dark);
}

.ProfileModal_email__VRVHJ {
  margin: 2px 0 0;
  font-size: 0.82rem;
  color: rgba(22, 22, 26, 0.65);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 300px;
}

.ProfileModal_actions__ntxO1 {
  display: grid;
  gap: 10px;
}

.ProfileModal_btnRow__eGnp3 {
  display: grid;
  gap: 10px;
}

.ProfileModal_btn__UPC1d {
  appearance: none;
  border: 1px solid var(--color-gray-border);
  background: var(--color-white);
  padding: 10px 12px;
  border-radius: 12px;
  font: inherit;
  cursor: pointer;
  font-weight: 800;
  transition: transform 120ms ease, box-shadow 160ms ease, border-color 160ms ease;
  text-align: center;
  text-decoration: none;
}

.ProfileModal_btn__UPC1d:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.10);
  border-color: rgba(171, 0, 96, 0.45);
}

.ProfileModal_btn__UPC1d:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.ProfileModal_btnPrimary__A3LAN {
  background: linear-gradient(135deg, var(--primary-light), var(--primary-dark));
  color: #fff;
  border-color: transparent;
  box-shadow: 0 10px 22px rgba(230, 5, 131, 0.22);
}

.ProfileModal_btnDanger__oJd2T {
  border-color: rgba(220, 38, 38, 0.35);
  color: rgb(200, 20, 20);
}

.ProfileModal_hint__HKOEl {
  margin: 0;
  font-size: 0.8rem;
  color: rgba(22, 22, 26, 0.65);
  line-height: 1.35;
}

.ProfileModal_error__hA1gC {
  margin: 0;
  font-size: 0.9rem;
  color: rgb(200, 20, 20);
  font-weight: 700;
}

.ProfileModal_fileInput__fbxy5 {
  display: none;
}

@media (prefers-reduced-motion: reduce) {
  .ProfileModal_closeBtn__1dv1D,
  .ProfileModal_btn__UPC1d {
    transition: none !important;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Profile/ProfileModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;IACvB,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,iDAAiD;EACjD,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,8EAA8E;EAC9E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gFAAgF;EAChF,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8EAA8E;EAC9E,WAAW;EACX,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;;IAEE,2BAA2B;EAC7B;AACF","sourcesContent":[".overlay {\n  position: fixed;\n  inset: 0;\n  background: transparent;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-end;\n  padding: 72px 5% 24px;\n  z-index: 200;\n}\n\n.modal {\n  width: min(340px, 100%);\n  background: var(--color-white);\n  border: 1px solid var(--color-gray-border);\n  border-radius: 14px;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.18);\n  overflow: hidden;\n}\n\n@media (max-width: 640px) {\n  .overlay {\n    justify-content: center;\n    padding: 72px 16px 24px;\n  }\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 12px 10px;\n  border-bottom: 1px solid var(--color-gray-border);\n  background: var(--color-white);\n}\n\n.titleWrap {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.title {\n  margin: 0;\n  font-size: 0.98rem;\n  font-weight: 800;\n  color: var(--color-text-dark);\n  letter-spacing: -0.01em;\n}\n\n.sub {\n  margin: 0;\n  font-size: 0.82rem;\n  color: rgba(22, 22, 26, 0.65);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.closeBtn {\n  appearance: none;\n  border: 1px solid var(--color-gray-border);\n  background: var(--color-white);\n  width: 36px;\n  height: 36px;\n  border-radius: 12px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 120ms ease, box-shadow 160ms ease, border-color 160ms ease;\n}\n\n.closeBtn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.10);\n  border-color: rgba(171, 0, 96, 0.45);\n}\n\n.closeBtn:focus-visible {\n  outline: 2px solid var(--color-main);\n  outline-offset: 2px;\n}\n\n.body {\n  padding: 12px;\n  display: grid;\n  gap: 10px;\n}\n\n.row {\n  display: grid;\n  gap: 10px;\n  justify-items: center;\n  text-align: center;\n}\n\n.avatar {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  border: 1px solid var(--color-gray-border);\n  overflow: hidden;\n  background: linear-gradient(135deg, var(--primary-light), var(--primary-dark));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-weight: 900;\n  letter-spacing: 0.4px;\n}\n\n.avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.rowText {\n  min-width: 0;\n}\n\n.name {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 800;\n  color: var(--color-text-dark);\n}\n\n.email {\n  margin: 2px 0 0;\n  font-size: 0.82rem;\n  color: rgba(22, 22, 26, 0.65);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 300px;\n}\n\n.actions {\n  display: grid;\n  gap: 10px;\n}\n\n.btnRow {\n  display: grid;\n  gap: 10px;\n}\n\n.btn {\n  appearance: none;\n  border: 1px solid var(--color-gray-border);\n  background: var(--color-white);\n  padding: 10px 12px;\n  border-radius: 12px;\n  font: inherit;\n  cursor: pointer;\n  font-weight: 800;\n  transition: transform 120ms ease, box-shadow 160ms ease, border-color 160ms ease;\n  text-align: center;\n  text-decoration: none;\n}\n\n.btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.10);\n  border-color: rgba(171, 0, 96, 0.45);\n}\n\n.btn:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.btnPrimary {\n  background: linear-gradient(135deg, var(--primary-light), var(--primary-dark));\n  color: #fff;\n  border-color: transparent;\n  box-shadow: 0 10px 22px rgba(230, 5, 131, 0.22);\n}\n\n.btnDanger {\n  border-color: rgba(220, 38, 38, 0.35);\n  color: rgb(200, 20, 20);\n}\n\n.hint {\n  margin: 0;\n  font-size: 0.8rem;\n  color: rgba(22, 22, 26, 0.65);\n  line-height: 1.35;\n}\n\n.error {\n  margin: 0;\n  font-size: 0.9rem;\n  color: rgb(200, 20, 20);\n  font-weight: 700;\n}\n\n.fileInput {\n  display: none;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .closeBtn,\n  .btn {\n    transition: none !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `ProfileModal_overlay__-Il9D`,
	"modal": `ProfileModal_modal__FrLVL`,
	"header": `ProfileModal_header__SeJ28`,
	"titleWrap": `ProfileModal_titleWrap__0ls9R`,
	"title": `ProfileModal_title__BCiG9`,
	"sub": `ProfileModal_sub__F38sC`,
	"closeBtn": `ProfileModal_closeBtn__1dv1D`,
	"body": `ProfileModal_body__WCJXy`,
	"row": `ProfileModal_row__ScdTB`,
	"avatar": `ProfileModal_avatar__nGRl-`,
	"rowText": `ProfileModal_rowText__mRqC5`,
	"name": `ProfileModal_name__Z29pR`,
	"email": `ProfileModal_email__VRVHJ`,
	"actions": `ProfileModal_actions__ntxO1`,
	"btnRow": `ProfileModal_btnRow__eGnp3`,
	"btn": `ProfileModal_btn__UPC1d`,
	"btnPrimary": `ProfileModal_btnPrimary__A3LAN`,
	"btnDanger": `ProfileModal_btnDanger__oJd2T`,
	"hint": `ProfileModal_hint__HKOEl`,
	"error": `ProfileModal_error__hA1gC`,
	"fileInput": `ProfileModal_fileInput__fbxy5`
};
export default ___CSS_LOADER_EXPORT___;
